import React from 'react';

const OrganizationIdContext = React.createContext<string | null>(null);
export default OrganizationIdContext;
